import axios from 'axios';
import axiosClient from './axiosClient';
import { unwrapApiResponse } from '../utils/unwrapApiResponse';

const apiBase = process.env.REACT_APP_API_BASE_URL;

const unwrapPublicResponse = (response) => {
  const body = response.data;

  if (!body?.success) {
    const error = new Error(body?.message || 'Request failed');
    error.errors = body?.errors || [];
    error.status = response.status;
    throw error;
  }

  return body.data;
};

export const submitContactMessage = async (payload) => {
  const response = await axios.post(`${apiBase}/api/contact-submissions`, payload);
  return unwrapPublicResponse(response);
};

export const getContactSubmissions = async () => {
  const response = await axiosClient.get('/api/admin/contact-submissions');
  return unwrapApiResponse(response);
};

export const getContactSubmissionById = async (id) => {
  const response = await axiosClient.get(`/api/admin/contact-submissions/${id}`);
  return unwrapApiResponse(response);
};

export const deleteContactSubmission = async (id) => {
  const response = await axiosClient.delete(`/api/admin/contact-submissions/${id}`);
  return unwrapApiResponse(response);
};
